export default __webpack_public_path__ + "static/media/Aperture.65ab4786.svg";